var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 173,
    viewBox: "0 0 169 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M163.504 106.325C161.796 117.762 159.168 129.126 155.881 139.655C153.599 149.707 150.199 158.392 145.577 164.773C141.368 170.04 135.368 172.443 127.45 171.549C119.566 169.649 109.565 165.02 97.6319 158.236C85.8331 152.281 73.3815 146.174 61.1164 140.574C49.2286 136.727 37.7462 133.012 27.5188 129.071C18.0504 126.008 10.3046 121.654 5.15223 115.564C1.29741 109.439 0.440613 101.059 3.05226 90.3838C6.92261 79.5045 13.4475 67.5553 21.6083 55.504C29.9852 43.7087 39.4365 32.3678 49.3076 22.5415C58.9876 13.619 69.1772 6.83665 79.5476 3.03904C89.9273 0.520018 100.789 1.1231 111.727 5.06548C122.775 9.61837 132.772 16.3081 141.273 24.1713C149.579 31.484 156.163 39.6576 160.652 48.3334C164.865 56.3091 167.077 65.1558 167.188 74.82C167.502 84.1604 166.243 94.7097 163.504 106.325Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector20);
export default __webpack_public_path__ + "static/media/Vector-20.56b9e76226e7d0795cef6a9cb87242fe.svg";
export { ForwardRef as ReactComponent };